import { bootToolPage } from '../lib/boot-tool'

const type = document.body.dataset.contentType === 'article' ? 'article' : 'qa'
bootToolPage(type)

document.querySelectorAll<HTMLElement>('[data-reading-progress]').forEach((bar) => {
  const paint = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight
    bar.style.width = `${max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 100}%`
  }
  paint()
  window.addEventListener('scroll', paint, { passive: true })
})
